import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
  },
  button: {
    color: theme.palette.text.secondary,
    padding: '10px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
  },
  title: {
    marginRight: 'auto',
  },
  active: {
    background: 'rgba(38, 50, 56, 0.04)',
  },
}))

export default useStyles
